import { createFileRoute } from "@tanstack/react-router";
import { BrasilDominationScore } from "@/components/admin/BrasilDominationScore";

export const Route = createFileRoute("/admin/brasil-domination")({
  head: () => ({
    meta: [
      { title: "Brasil Domination Score — VerseSport Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: BrasilDominationPage,
});

function BrasilDominationPage() {
  return (
    <main className="mx-auto max-w-3xl space-y-3 px-3 py-4">
      <header>
        <h1 className="text-xl font-black">🇧🇷 Brasil Command Center</h1>
        <p className="text-[12px] text-muted-foreground">
          Painel executivo da operação Brasil — retenção, shares, referrals, conversões,
          influencers e torcidas por estado.
        </p>
      </header>
      <BrasilDominationScore />
    </main>
  );
}